import React from "react"

import * as championshipOverviewStyles from "../../styles/world_championships/ChampionshipOverview.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

export default function ChampionshipOverview(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `championship-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subtitle = ChildSelector.select(
    content,
    `championship-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const text = ChildSelector.select(
    content,
    `championship-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const description = ChildSelector.select(
    content,
    `championship-description`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const highlightText = ChildSelector.select(
    content,
    `championship-highlight`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  
  return (
    <section 
      id="championship-overview" 
      className={`${championshipOverviewStyles.overviewSection} ${props.className || ''}`}
    >
      <div className={championshipOverviewStyles.container}>
        {title && (
          <h2 
            className={championshipOverviewStyles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {subtitle && (
          <h4 
            className={championshipOverviewStyles.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
        <div className={championshipOverviewStyles.contentBox}>
          {text && (
            <p 
              className={championshipOverviewStyles.text}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
          {description && (
            <p 
              className={championshipOverviewStyles.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {highlightText && (
            <p 
              className={championshipOverviewStyles.highlightText}
              dangerouslySetInnerHTML={{ __html: highlightText }}
            />
          )}
        </div>
      </div>
    </section>
  )
}
